import { render, staticRenderFns } from "./AddonHorizontalView.vue?vue&type=template&id=371cd7c0&scoped=true"
import script from "./AddonHorizontalView.vue?vue&type=script&lang=js"
export * from "./AddonHorizontalView.vue?vue&type=script&lang=js"
import style0 from "./AddonHorizontalView.vue?vue&type=style&index=0&id=371cd7c0&prod&lang=scss&scoped=true"
import style1 from "./AddonHorizontalView.vue?vue&type=style&index=1&id=371cd7c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371cd7c0",
  null
  
)

export default component.exports